import { setZoom, setSelectedArea } from '../map';
import setCoordinate from './setCoordinate';
import setAddress from './setAddress';

/**
 * Set the panorama id from the supplied coordinate.
 * @param {!object} coordinate A coordinate.
 * @param {number} zoom The zoom level
 * @return {function} action dispatcher.
 */
export default (coordinate, zoom) => (dispatch, getState) => {
  const { ui } = getState();
  const useSelectedArea = !ui.isMapUi;

  dispatch(setZoom(zoom, false));
  dispatch(setCoordinate(coordinate, false));
  dispatch(setSelectedArea(
      useSelectedArea ? { ...coordinate, radius: 5000 } : null,
      false,
  ));
  dispatch(setAddress(coordinate));
};
